module.exports = __webpack_public_path__ + "media/images/smart_phone/ticket/icon_06-e72f2b540d2fa78e98431e985b55b055.png";